import { Card, CardContent, CardHeader, CardTitle } from '@cibli/shared';

export function ApiInfoCard() {
  const apiUrl = import.meta.env.VITE_API_URL;

  return (
    <Card>
      <CardHeader>
        <CardTitle>API</CardTitle>
      </CardHeader>
      <CardContent>
        <p className="text-sm font-mono bg-gray-100 p-2 rounded border">{apiUrl}</p>
      </CardContent>
    </Card>
  );
}
